function createHeaders(jwt) {
    const headers = {
        "Content-Type": "application/json"
    };

    if (jwt)
        headers.Authorization = `Bearer ${jwt}`;

    return headers;
}

export function HttpNoData(url, method, jwt) {
    return fetch(url, {
        method,
        headers: createHeaders(jwt)
    });
}

export function HttpData(url, method, jwt, body) {

    return fetch(url, {
        method,
        headers: createHeaders(jwt),
        body: JSON.stringify(body),
    });
}

export async function DownloadFile(url, method, jwt, body, fileName) {

    try {
        var response = await fetch(url, {
            method,
            headers: createHeaders(jwt),
            body: JSON.stringify(body),
        });

        if (!response.ok)
            return { statusSuccessful: false, error: response.status };

            try {

                const blob = await response.blob();
                const urlTemp = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = urlTemp;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                return { statusSuccessful: true, isSave: true};
            } catch (error) {
                return { statusSuccessful: true, isSave: false };
            }
    } catch (error) {
        return { statusSuccessful: false, error: error };
    }
}

export function getRandomColor() {
    // Гарантируем, что цвет не слишком темный или светлый
    var getComponent = function () {
        var value = Math.floor(Math.random() * 256);
        return (value < 16 ? '0' : '') + value.toString(16);
    };

    var color = '#' + getComponent() + getComponent() + getComponent();
    return color;
}

export function getRandomInt(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
  }

export function TimeOnlyParse(time) {

    const date = time.split(':');

    if (date.length === 3) {
        const hours = date[0];
        const minutes = date[1];
        const seconds = date[2];

        return hours + "ч. " + minutes + "мин. " + seconds + "сек.";
    }
    else if (date.length === 2) {
        const minutes = date[0];
        const seconds = date[1];

        return minutes + "мин. " + seconds + "сек.";
    }

    return '';
}

export function TimeSpanParse(value) {

    var points = value.split('.');

    if (points.length === 3)
        return points[0] + "д. " + TimeOnlyParse(points[1]);
    if (points.length === 2 || value.length >= 8)
        return TimeOnlyParse(points[0]);

    return '';
}

export function GetHoursOnTimeSpan(value){
    var points = value.split('.');

    if (points.length === 3)
        return (+points[0] * 24) + +points[1].split(':')[0];
    if (points.length === 2 || value.length >= 8)
        return +points[0].split(':')[0];

    return '';
}

export function NormalStringTime(value){

    return value.toLocaleString(undefined, 
        {
            hour: 'numeric',
            minute: 'numeric'
        });
}

export function Exit() {
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    window.location.href = '/';
}
